// import Vue from "vue";
// import { Button, Message, MessageBox } from "ELEMENT-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

locale.use(lang);

Vue.component(ELEMENT.Button.name, ELEMENT.Button);
Vue.component(ELEMENT.MessageBox.name, ELEMENT.MessageBox);
Vue.prototype.$message = ELEMENT.Message;
